import { LoaderCirleModule } from 'src/app/ui-components/loader-cirle/loader-cirle.module';
import { ButtonModule } from 'src/app/ui-components/buttons/button.module';
import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { MultiselectPanelComponent } from "./multiselect-panel.component";

@NgModule({
  declarations:[MultiselectPanelComponent],
  imports:[CommonModule,ButtonModule,LoaderCirleModule],
  exports:[MultiselectPanelComponent]
})
export class MultiSelectPanelDropdown{
  constructor() {

  }
}
